export default __webpack_public_path__ + "static/media/home-mobile-hero3.b519a754.png";